import blockchairLogo from '@/assets/images/logo/blockchair.svg';
import veritasLogo from '@/assets/images/logo/veritas.svg';

export type PartnerKey = 'blockchair' | '894e1';

type Partner = {
  logo: string;
  label: string;
};

export const LOGOS: Record<PartnerKey, Partner> = {
  blockchair: {
    logo: blockchairLogo,
    label: 'Blockchair',
  },
  '894e1': {
    logo: veritasLogo,
    label: 'Veritas',
  },
};

export const allowedPartners: PartnerKey[] = ['blockchair', '894e1'];
